/**
 * @file Route related utilities.
 */

import { BASENAME } from '../constants/basenames';

const basenames = [
  BASENAME.PRO,
  BASENAME.CAMPS,
  BASENAME.SCHOOLS,
  BASENAME.SHUTTERBUG,
  BASENAME.RESORTS,
  BASENAME.GREEK,
  BASENAME.SPORTS,
  BASENAME.CHURCH,
  BASENAME.EVENTS,
];
const basenamePattern = `:basename(${basenames.join('|')})`;
const shutterbugPattern = `:basename(${BASENAME.SHUTTERBUG})`;

export { basenamePattern, shutterbugPattern };
